/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_VALUES } from "../graphql/getValues.query";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IValuesMethods extends IPluginMethodMap {
    getValues(args: any): Promise<any>;
}

export class ValuesService implements IAgentPlugin {
    readonly methods: IValuesMethods;

    constructor() {
        this.methods = {
            getValues: this.getValuesProps.bind(this),
        };
    }

    async getValuesProps(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("hifiAtt->", args);
        const filter = args?.id ? {
            costumeType: {
                eq: args?.id,
            },
        } : {};
        let addOnFilter = {};
        if (args?.id) {
            addOnFilter = {
                costumeType: {
                    eq: args?.id,
                },
            };
        }
        if (args?.fid) {
            addOnFilter = {
                ...addOnFilter, _id: { eq: args?.fid },
            };
        }
        if (args?.att) {
            addOnFilter = { ...addOnFilter, CA___name: { eq: args?.att } };
        }

        console.log("hifiAttadd->", addOnFilter);

        try {
            if (client) {
                if(args?.id && args?.fid && args?.att){
                    const res = await client.query({
                        query: GET_VALUES,
                        variables: {
                            filters: addOnFilter
                        },
                        fetchPolicy: "network-only",
                    });
    
                    if (res?.data) {
                        console.log("hifiAttres=>", res?.data?.getFullCostumeFeatureInventories?.content)
                        return {
                            searchValueFilter: this.format(res?.data?.getFullCostumeFeatureInventories?.content) ?? []
                        };
                    }
                }
                else{
                    return{
                        searchValueFilter:[]
                    }
                }
                
            }
        } catch (err: any) {
            console.log(`error in table data`, err);
            return {
                isEmpty: true,
            };
        }
    }
    private format(data: any) {
        const uniqueCVNames = new Set();
        data.forEach(item => {
            uniqueCVNames.add(item.CV.name);
        });

        const uniqueCVNamesArray = Array.from(uniqueCVNames);
        console.log("uniqueCVNamesArray==>",uniqueCVNamesArray)
        return uniqueCVNamesArray.map((_item) => {
            return {
                label: _item,
                value: _item,
            };
        });
    }
}
